import axios from 'axios'
import type { GroupItem, Item, Variant } from 'BrokerTsLib/src/dtos'
import { PackageItemTypeCategory, Risk, RiskVariant } from 'BrokerTsLib/src/enums'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { returnArray } from 'BrokerTsLib/src/Utils/reactQueryUtils'
import type { UseQueryResult } from 'react-query'
import { useQuery } from 'react-query'

import type { GenericQueryOptions} from '.'
import { useUrl } from '.'
import { useApp } from './useApp'

export const useGetRisks = (options?: GenericQueryOptions<GroupItem[]>): UseQueryResult<GroupItem[], any> => {
  const url = useUrl()
  const { product } = useApp()

  return useQuery({
    queryKey: ['GetRisks', 'property', product],
    queryFn: () => axios.get<Item[]>(`${url}/GetRisks`).then(returnArray),
    staleTime: longStaleTime,
    ...options
  })
}

export const useGetGroupedRisks = (variant: Variant, ignoreRiskIds?: Risk[]) => {
  const { data } = useGetRisks({ refetchOnWindowFocus: false, refetchOnMount: false })

  const risks = data ?? []
  const typeRiskVariant = variant.variantParts?.find(x => x.risk == Risk.PROPERTY_TYPE)?.riskVariant

  const result = risks
    .filter(x => {
      if (!typeRiskVariant || typeRiskVariant == RiskVariant.HouseholdAndRealty) return true
      if (typeRiskVariant == RiskVariant.Household) return Number(x.groupId) != PackageItemTypeCategory.Realty
      if (typeRiskVariant == RiskVariant.Realty) return Number(x.groupId) != PackageItemTypeCategory.Household

      console.log('Invalid variant', variant)
      return false
    })
    .filter(x => !ignoreRiskIds || !ignoreRiskIds.includes(x.id))
    .reduce((pv, cv) => {
      return {
        ...pv,
        [cv.groupOrder ?? '']: [...(pv[cv.groupOrder ?? ''] ?? []), cv]
      }
    }, {} as { [n: string]: GroupItem[] })

  return result
}